<template>
  <slot></slot>
  <modal :id="modalId" :title="title" @shown="mountPreview">
    <form :id="formId" :action="actionFileUpload" method="POST">

      <upload-box
        ref="uploadBox"
        :url="actionFileUpload"
        :addRemoveLinks="false"
        :max-filesize="512"
        :timeout="600000"
        :thumbnail-width="200"
        :thumbnail-height="200"
        param-name="upload"
        @sending="onSending"
        @addedfile="dzFilesAdded"
        @removedfile="dzFileRemoved"
        @queuecomplete="dzCompleteMultiple"
        @success="dzSuccess"
        @error="dzUploadError"
      />

      <div ref="dzFormTemplate" class="d-none border-bottom">
        <!-- This is used as the form preview template -->
        <div>
          <span class="preview"><img data-dz-thumbnail /></span>
        </div>
        <div>
          <p class="name" data-dz-name></p>
          <strong class="error text-danger" data-dz-errormessage></strong>
        </div>
        <div>
          <p class="size" data-dz-size></p>
          <div class="progress active" role="progressbar" aria-valuemin="0" aria-valuemax="100" aria-valuenow="0">
            <div class="progress-bar progress-bar-success" style="width:0%;" data-dz-uploadprogress></div>
          </div>
        </div>

        <div class="form-group row">
          <div class="col-sm-12">
            <select class="form-control field-type">
              <option value="">Select upload type...</option>
              <option v-for="type in fileTypes" :value="type.id">{{ type.value }}</option>
            </select>
            <div class="type-validation text-danger d-none">Please select upload type.</div>
          </div>
        </div>

        <div class="form-group row mt-2">
          <div class="col-sm-12">
            <textarea class="form-control field-description" placeholder="Enter file description..." rows="2"></textarea>
          </div>
        </div>

        <div class="form-group row">
          <div class="col-sm-12 text-right">
            <button data-dz-remove class="btn btn-sm btn-danger delete">
              <i class="fa fa-trash"></i>
              <span> Delete</span>
            </button>
          </div>
        </div>
      </div>

      <slot name="hidden"></slot>
    </form>

    <template #footer>
      <a class="btn btn-default" @click="hideModal"><i class="fa fa-fw fa-close"></i> Cancel</a>
      <a :class="{'btn': true, 'btn-primary': true, 'disabled': !uploadEnabled}" @click.prevent="upload">
        <i class="fa fa-fw fa-upload"></i> Upload <i v-if="loading" class="fa fa-spinner fa-spin"></i>
      </a>
    </template>

  </modal>
</template>

<script>
import HasModal from "./../mixins/HasModal";

export default {
  mixins: [HasModal],

  emits: ['uploaded'],

  props: {

    // Modal dialog id.
    modalId: {
      required: false,
      type: String,
      default: 'fileUploadModal'
    },

    // File upload action URL.
    actionFileUpload: {
      type: String,
      default: ""
    },

    // Form title.
    title: {
      type: String,
      default: ""
    },

    fileTypes: {
      type: Array,
      required: true,
    },

  },

  /**
   * Variables (models).
   */
  data() {
    return {
      filesQueueNotEmpty: false,
      queuedFiles: [],
      loading: false,
    }
  },

  /**
   * Computed values
   */
  computed: {

    formId() {
      return this.modalId + "-form"
    },

    uploadEnabled() {
      return (this.queuedFiles.length > 0) && !this.loading;
    }

  },

  /**
   * Functions (methods).
   */
  methods: {

    mountPreview() {
      // Set file preview custom markup.
      let preview = this.$refs.dzFormTemplate;
      preview.removeAttribute('id');
      preview.classList.remove('d-none');
      preview.remove();
      this.$nextTick(() => {
        this.$refs.uploadBox.dropzone.options.previewTemplate = preview.outerHTML;
      })

      this.loading = false;
    },

    onSending(file, xhr, formData) {
      let file_type = file.previewElement.querySelector('.field-type').value;
      let description = file.previewElement.querySelector('.field-description').value;
      formData.append('file_type', file_type);
      formData.append('description', description);
    },

    dzFilesAdded(file) {
      this.updateQueuedFiles();
    },

    dzSuccess(file) {
      this.$refs.uploadBox.removeFile(file);
      let upload = JSON.parse(file.xhr.response);
      this.$emit('uploaded', upload);

      const claimFilesComponent = this.$root.$refs.claimFiles;
      if (claimFilesComponent !== undefined) {
        claimFilesComponent.files.unshift(upload);

        const bulkOpsComponent = claimFilesComponent.$refs.bulkOperations;
        if (bulkOpsComponent !== undefined) {
          const emailComposeComponent = bulkOpsComponent.$refs.emailCompose;
          if (emailComposeComponent !== undefined) {
            emailComposeComponent.loadClaimUploads();
          }
        }
      }

      this.updateQueuedFiles();
    },

    dzCompleteMultiple() {
      this.updateQueuedFiles();
      this.hideModal();
    },

    dzFileRemoved(file) {
      this.updateQueuedFiles();
    },

    dzUploadError(file, error, xhr) {

      let errorMessage = 'Failed to upload file.';
      if (xhr) if (xhr.status === 422) {
        errorMessage = error.message;
      }

      file.previewElement.querySelector('[data-dz-errormessage]').innerText = errorMessage;
    },

    upload() {
      let errorsNum = 0;

      document.getElementById(this.formId).querySelectorAll('.field-type').forEach(el => {
        if (el.value === '') {
          errorsNum++;
          el.nextSibling.classList.remove('d-none');
          return;
        }
        el.nextSibling.classList.add('d-none');
      });

      if (errorsNum === 0) {
        this.$refs.uploadBox.process();
        this.loading = true;
      }
    },

    updateQueuedFiles() {
      this.$nextTick(() => {
        this.queuedFiles = this.$refs.uploadBox.getQueuedFiles();
      });
    }

  }
}
</script>
